export default __webpack_public_path__ + "static/media/listIconCircle.895fe25f.png";